import * as React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const SVGComponent = ({ color = '#F2F7FF', ...props }: { color?: string }) => (
  <Svg width={48} height={48} viewBox="0 0 48 48" fill="none" {...props}>
    <G clipPath="url(#clip0_1051_8257)">
      <Rect width={48} height={48} rx={8} fill="#F2F7FF" />
      <G clipPath="url(#clip1_1051_8257)">
        <Path
          d="M37.0041 24.8133L24.1939 16.6987C23.8718 16.4946 23.4612 16.4946 23.1391 16.6987L10.3289 24.8133C9.95736 25.0486 9.78587 25.5018 9.90801 25.9249C10.0302 26.348 10.4168 26.6392 10.8563 26.6392H36.4766C36.9161 26.6392 37.3027 26.348 37.4249 25.9249C37.5472 25.5018 37.3756 25.0486 37.0041 24.8133Z"
          fill="url(#paint0_radial_1051_8257)"
        />
        <Path
          d="M34.7922 27.2309H31.3565C30.8113 27.2309 30.3693 27.6739 30.3693 28.2204V42.7126C30.3693 43.259 30.8113 43.702 31.3565 43.702H34.7922C35.3374 43.702 35.7794 43.259 35.7794 42.7126V28.2204C35.7794 27.6739 35.3374 27.2309 34.7922 27.2309Z"
          fill="#8BB7FF"
        />
        <Path
          d="M25.3843 27.2309H21.9487C21.4034 27.2309 20.9614 27.6739 20.9614 28.2204V42.7126C20.9614 43.259 21.4034 43.702 21.9487 43.702H25.3843C25.9296 43.702 26.3716 43.259 26.3716 42.7126V28.2204C26.3716 27.6739 25.9297 27.2309 25.3843 27.2309Z"
          fill="#8BB7FF"
        />
        <Path
          d="M15.9096 27.2309H12.4739C11.9287 27.2309 11.4867 27.6739 11.4867 28.2204V42.7126C11.4867 43.259 11.9287 43.702 12.4739 43.702H15.9096C16.4549 43.702 16.8968 43.259 16.8968 42.7126V28.2204C16.8968 27.6739 16.4548 27.2309 15.9096 27.2309Z"
          fill="#8BB7FF"
        />
        <Path
          d="M38.3075 24.6604H9.02585C8.01224 24.6604 7.1875 25.4869 7.1875 26.5029V28.3971C7.1875 29.413 8.01217 30.2397 9.02585 30.2397H38.3076C39.3212 30.2397 40.146 29.4131 40.146 28.3971V26.5029C40.1459 25.4869 39.3212 24.6604 38.3075 24.6604Z"
          fill="url(#paint1_radial_1051_8257)"
        />
        <Path
          d="M36.4765 40.7747H10.8561C10.3109 40.7747 9.8689 41.2177 9.8689 41.7642V45.3645C9.8689 45.911 10.3109 46.354 10.8561 46.354H36.4764C37.0217 46.354 37.4637 45.911 37.4637 45.3645V41.7642C37.4638 41.2177 37.0218 40.7747 36.4765 40.7747Z"
          fill="url(#paint2_radial_1051_8257)"
        />
        <Path
          d="M39.1591 44.3749H8.17511C7.62986 44.3749 7.18787 44.8179 7.18787 45.3644V48.9647C7.18787 49.5112 7.62986 49.9542 8.17511 49.9542H39.159C39.7043 49.9542 40.1463 49.5112 40.1463 48.9647V45.3644C40.1463 44.8179 39.7043 44.3749 39.1591 44.3749Z"
          fill="url(#paint3_radial_1051_8257)"
        />
        <Path
          d="M45.5 24C45.5 29.799 40.799 34.5 35 34.5C31.943 34.5 29.1911 33.1937 27.2724 31.1087C26.7684 30.5614 26.3223 29.9601 25.9426 29.3151C25.0259 27.756 24.5 25.9393 24.5 24C24.5 18.201 29.201 13.5 35 13.5C36.9397 13.5 38.7564 14.0259 40.3151 14.943C40.9601 15.3223 41.561 15.7684 42.1083 16.2729C44.1933 18.1907 45.5 20.943 45.5 24Z"
          fill="#F2F7FF"
        />
        <Path
          d="M44 24C44 28.9706 39.9706 33 35 33C32.3797 33 30.021 31.8803 28.3764 30.0932C27.9444 29.6241 27.562 29.1087 27.2365 28.5558C26.4507 27.2194 26 25.6622 26 24C26 19.0294 30.0294 15 35 15C36.6626 15 38.2198 15.4507 39.5558 16.2369C40.1087 16.562 40.6237 16.9444 41.0928 17.3767C42.88 19.0206 44 21.3797 44 24Z"
          fill="url(#paint4_radial_1051_8257)"
        />
        <Path
          d="M33.3216 29.9395C33.2457 29.9395 33.1686 29.9247 33.0942 29.8935C32.7946 29.7678 32.6537 29.423 32.7794 29.1235L37.0952 18.8397C37.221 18.5401 37.5658 18.3994 37.8653 18.5249C38.1649 18.6506 38.3058 18.9954 38.1801 19.295L33.8643 29.5786C33.7698 29.8039 33.5514 29.9395 33.3216 29.9395Z"
          fill="white"
        />
        <Path
          d="M32.4953 23.6084C31.1194 23.6084 30 22.3504 30 20.8042C30 19.258 31.1194 18 32.4953 18C33.8711 18 34.9905 19.258 34.9905 20.8042C34.9905 22.3504 33.8711 23.6084 32.4953 23.6084ZM32.4953 19.1765C31.7682 19.1765 31.1765 19.9067 31.1765 20.8042C31.1765 21.7017 31.7682 22.4319 32.4953 22.4319C33.2224 22.4319 33.814 21.7017 33.814 20.8042C33.814 19.9067 33.2224 19.1765 32.4953 19.1765Z"
          fill="white"
        />
        <Path
          d="M38.3243 30.6397C36.9485 30.6397 35.8291 29.3817 35.8291 27.8355C35.8291 26.2893 36.9485 25.0312 38.3243 25.0312C39.7002 25.0312 40.8196 26.2893 40.8196 27.8355C40.8196 29.3818 39.7002 30.6397 38.3243 30.6397ZM38.3243 26.2078C37.5972 26.2078 37.0056 26.938 37.0056 27.8355C37.0056 28.733 37.5972 29.4632 38.3243 29.4632C39.0514 29.4632 39.643 28.733 39.643 27.8355C39.643 26.9379 39.0515 26.2078 38.3243 26.2078Z"
          fill="white"
        />
      </G>
    </G>
    <Defs>
      <RadialGradient
        id="paint0_radial_1051_8257"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.2199 17.9491) rotate(149.547) scale(15.5412 18.0281)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint1_radial_1051_8257"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(29.1051 25.4362) rotate(164.778) scale(16.583 11.1542)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint2_radial_1051_8257"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(46.5219 36.4597) rotate(159.061) scale(26.3 16.8077)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint3_radial_1051_8257"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(37.6387 44.7381) rotate(169.709) scale(28.2846 9.24649)"
      >
        <Stop stopColor="#9DC2FF" />
        <Stop offset={1} stopColor="#3D7FEB" />
      </RadialGradient>
      <RadialGradient
        id="paint4_radial_1051_8257"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.1121 18.5115) rotate(141.6) scale(8.20686 7.41557)"
      >
        <Stop stopColor="#FFE0B9" />
        <Stop offset={1} stopColor="#DCAD70" />
      </RadialGradient>
      <ClipPath id="clip0_1051_8257">
        <Rect width={48} height={48} rx={8} fill="white" />
      </ClipPath>
      <ClipPath id="clip1_1051_8257">
        <Rect width={40} height={42} fill="white" transform="translate(7 7)" />
      </ClipPath>
    </Defs>
  </Svg>
)
export default SVGComponent
